import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

const tabs = [{ slug: "hot", name: "全站热榜" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function Ranking() {
  const [active, setActive] = useState("hot");

  const list = useMemo(() => {
    let arr = comics.slice().sort((a, b) => b.rating - a.rating);
    if (active !== "hot") {
      const cat = categories.find((c) => c.slug === active);
      if (cat) arr = arr.filter((c) => c.category === cat.name);
    }
    return arr.slice(0, 10);
  }, [active]);

  const rankColor = (i: number) => (i === 0 ? "text-accent-500" : i === 1 ? "text-secondary-500" : i === 2 ? "text-primary-500" : "text-foreground-400");

  return (
    <div className="pt-16">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-4 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑导航">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="font-medium text-foreground-950">人气排行</span>
          </nav>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">天堂漫画人气排行榜</h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            根据全站漫画海量资源的阅读热度与读者评分综合排序，热门连载、口碑佳作一目了然。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {tabs.map((t) => (
            <button
              key={t.slug}
              onClick={() => setActive(t.slug)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === t.slug ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        <ol className="mx-auto mt-10 max-w-3xl space-y-3">
          {list.map((c, i) => (
            <li
              key={c.id}
              className="group flex cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-ink-sm"
            >
              <span className={`w-10 shrink-0 text-center font-heading text-2xl font-black ${rankColor(i)}`}>
                {i + 1}
              </span>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md">
                <img src={c.cover} alt={`${c.title} 封面`} className="h-full w-full object-cover object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <h2 className="truncate font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">{c.title}</h2>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-900">{c.category}</span>
                  <span>{c.chapters}</span>
                  <span>{c.views} 人气</span>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-1.5 w-24 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-accent-500" style={{ width: `${Math.min(100, c.rating * 10)}%` }}></div>
                  </div>
                  <span className="flex items-center gap-0.5 text-xs text-accent-600">
                    <i className="ri-star-fill"></i>
                    <b>{c.rating}</b>
                  </span>
                </div>
              </div>
              <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-700 sm:block">
                {c.latest}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}